module.exports = __webpack_public_path__ + "static/media/38.725ae91d.JPG";